<script>
  export let compact = false;
</script>

<div
  class="us-house-legend"
  class:text-base={!compact}
  class:text-sm={compact}
  aria-hidden="true"
>
  <span class="legend-label legend-label--previous">
    Current seat
  </span>

  <svg
    class="legend-square"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    width="40"
    height="40"
    aria-hidden="true"
  >
    <rect
      id="us-house-current-election-fill"
      x="1.5"
      y="1.5"
      width="37"
      height="37"
      fill="#cecccc"
    />

    <rect
      id="us-house-previous-term-outline"
      x="2"
      y="2"
      width="36"
      height="36"
      fill="none"
      stroke="#777"
      stroke-width="4"
    />

    <line
      id="us-house-pointer-previous"
      x1="-20"
      y1="20"
      x2="1.5"
      y2="20"
      stroke="#222"
      stroke-width="1.5"
    />

    <line
      id="us-house-pointer-current"
      x1="20"
      y1="20"
      x2="54"
      y2="20"
      stroke="#222"
      stroke-width="1.5"
    />
  </svg>

  <span class="legend-label legend-label--current">
    Winner
  </span>
</div>